import { useCallback } from "react"

import { Flex } from "antd"
import { useTranslation } from "react-i18next"

import { DashboardFiltersBlock } from "../../../Components/Filters/DashboardFiltersBlock/DashboardFiltersBlock"
import DropdownBlockCheckbox from "../../../Components/Filters/DropdownBlockCheckbox"
import { useDeflectFilters } from "../hooks/useDeflectFilters"
import { PROGRAM_OPTIONS } from "../utils/vocabulary"

import styles from "../analytics.module.less"

const toPrograms = (value) =>
  value === "all" || value == null ? [] : Array.isArray(value) ? value : [value]

// Calendar, Compare and Program, for the Analytics page and its inner pages. An inner page passes
// its route as `page` and writes to its own window, so changing it there leaves the Analytics page
// alone. `withCompare` is off where nothing on the page shows a comparison, `withProgram` where the
// page filters by program itself.
const DeflectFilters = ({ page, withCompare = true, withProgram = true }) => {
  const { t } = useTranslation()
  const { filters, change } = useDeflectFilters(page)

  // A custom range arrives as a bare [from, to]; stored the way Home and Health store it, which
  // is the shape the Compare control reads to tell a custom window from a relative one.
  const handleChangeFilter = useCallback(
    (patch) =>
      change(
        Array.isArray(patch.period)
          ? { ...patch, period: { type: "custom", period: patch.period } }
          : patch
      ),
    [change]
  )

  return (
    <Flex justify="flex-start" align="center" gap={12} wrap="wrap" className={styles.filterRow}>
      <DashboardFiltersBlock
        onlyPeriod
        showCompare={withCompare}
        filters={filters}
        handleChangeFilter={handleChangeFilter}
      />
      {withProgram && (
        <DropdownBlockCheckbox
          id="program"
          label={t("Program")}
          iconType="type"
          type="chart"
          allBtnText={t("All programs")}
          data={PROGRAM_OPTIONS}
          sortDisabled
          dropdownFilters={filters.program?.length ? filters.program : "all"}
          setDropdownFilters={(obj) => change({ program: toPrograms(obj.program) })}
        />
      )}
    </Flex>
  )
}

export default DeflectFilters
